/* Builds customer messages from confirmed cart state, never from an inferred stock count. */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.JoaninhaCartFeedback = api;
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  var defaults = {
    unit: '__count__ unidade', units: '__count__ unidades',
    invalidQuantity: 'Informe uma quantidade inteira a partir de 1. Para retirar o item, use Remover ou informe 0.',
    loading: 'Atualizando sua sacola…', wait: 'Aguarde a atualização da sacola antes de continuar.',
    confirmed: 'A sacola foi atualizada.',
    added: 'Adicionamos __added__. Sua sacola tem __total__ deste item.',
    partial: 'Adicionamos __added__ das __requested__ solicitadas. Sua sacola tem __total__ deste item. Revise a quantidade antes de continuar.',
    notAdded: 'Nenhuma unidade foi adicionada. Sua sacola continua com __total__ deste item. Confira a opção escolhida antes de tentar novamente.',
    validation: 'Não foi possível concluir esta solicitação. Revise a opção e a quantidade do produto antes de tentar novamente.',
    limited: 'Não foi possível adicionar mais deste item. Sua sacola continua com __total__. Você pode continuar com essa quantidade.',
    unavailable: 'Este item não está disponível para compra no momento. Escolha outra opção ou continue explorando a coleção.',
    addRejected: 'Não foi possível adicionar a quantidade solicitada. Escolha uma quantidade menor e tente novamente.',
    changed: 'A quantidade na sacola foi atualizada para __total__.',
    adjusted: 'Não foi possível manter a quantidade solicitada. A sacola ficou com __total__ deste item. Confira antes de continuar.',
    unchanged: 'Não foi possível alterar a quantidade. A sacola continua com __total__ deste item.',
    removed: 'Item removido da sacola.',
    removeFailed: 'Não foi possível remover o item. Ele continua na sacola com __total__. Tente remover novamente.',
    unknown: 'Não foi possível confirmar a alteração. Confira a sacola antes de tentar de novo para evitar itens duplicados.',
    notSent: 'Não foi possível carregar sua sacola. Nenhuma alteração foi enviada. Tente novamente em instantes.',
    rateLimit: 'A loja recebeu muitas tentativas em pouco tempo. Aguarde alguns instantes antes de tentar novamente.',
    service: 'A loja não conseguiu concluir a solicitação agora. Confira a sacola e tente novamente em instantes.',
    network: 'A conexão foi interrompida durante a atualização. Confira a sacola antes de tentar novamente.',
    invalidVariant: 'Esta opção de produto não está mais disponível. Atualize a página para escolher uma opção atual.',
    viewCart: 'Conferir sacola', reload: 'Atualizar página',
    noteError: 'Não foi possível confirmar o salvamento da observação. Seu texto foi mantido nesta página. Tente salvar novamente antes de finalizar.',
    noteSaving: 'Salvando observação…', noteSaved: 'Observação salva.', noteRetry: 'Salvar observação novamente'
  };
  function text(key, values) {
    var result = (root.JoaninhaMessages && root.JoaninhaMessages.cart && root.JoaninhaMessages.cart[key]) || defaults[key] || key;
    return result.replace(/__(\w+)__/g, function (_, name) { return values && values[name] !== undefined ? String(values[name]) : ''; });
  }
  function units(n) { return text(n === 1 ? 'unit' : 'units', { count: n }); }
  function reason(status, payload) {
    var detail = String(payload && (payload.description || payload.message) || '').toLowerCase();
    if (status === 429) return 'rateLimit';
    if (status >= 500) return 'service';
    if (status === 404 || /cannot find variant|variant.*not found|invalid.*variant|variante.*inválid/.test(detail)) return 'invalidVariant';
    if (/sold out|esgotad|fora de estoque/.test(detail)) return 'unavailable';
    if (/stock|inventory|estoque|maximum quantity|quantidade máxima|available|disponib|only .* added/.test(detail)) return 'inventory';
    if (status >= 400 && status < 500) return 'validation';
    return 'service';
  }
  function describe(context) {
    var c = context, key, kind = 'error', action = null;
    var actual = c.actual, before = c.before, sent = c.requested;
    var verified = Number.isSafeInteger(actual) && actual >= 0;
    var knownBefore = Number.isSafeInteger(before) && before >= 0;
    var why = reason(c.status || 0, c.payload);
    if (c.notSent) key = 'notSent';
    else if (!verified || c.rendered === false) { key = 'unknown'; action = 'cart'; }
    else if (c.operation === 'add') {
      var delta = knownBefore ? actual - before : null;
      if (delta !== null && delta > 0 && delta < sent) { key = 'partial'; kind = 'warning'; action = 'cart'; }
      else if (delta !== null && delta >= sent) { key = 'added'; kind = 'success'; }
      else if (c.ok && knownBefore && actual === before) { key = 'notAdded'; kind = 'warning'; action = 'cart'; }
      else if (c.ok && !knownBefore) { key = 'unknown'; action = 'cart'; }
      else if (why === 'inventory' && actual > 0) { key = 'limited'; kind = 'warning'; action = 'cart'; }
      else if (why === 'unavailable') key = 'unavailable';
      else if (why === 'inventory') key = 'addRejected';
      else { key = c.network ? 'network' : why; action = why === 'invalidVariant' ? 'reload' : 'cart'; }
    } else if (sent === 0) {
      if (actual === 0) { key = 'removed'; kind = 'success'; }
      else { key = 'removeFailed'; action = 'cart'; }
    } else if (actual === sent) { key = 'changed'; kind = 'success'; }
    else if (c.ok || why === 'inventory' || why === 'unavailable') {
      key = knownBefore && actual === before ? 'unchanged' : 'adjusted'; kind = 'warning';
    } else { key = c.network ? 'network' : why; action = why === 'invalidVariant' ? 'reload' : 'cart'; }
    return { key: key, kind: kind, action: action, message: text(key, {
      total: units(actual), added: units(Math.max(0, actual - before)), requested: units(sent)
    }) };
  }
  return { describe: describe, reason: reason, text: text, defaults: defaults };
});
